// Resolution order for the matchmaking endpoint:
//   1. window.APP_CONFIG — public/config.js, which CDK overwrites at deploy time
//      with the real API Gateway endpoint for the stage.
//   2. VITE_WS_API_URL   — build-time override for local dev (.env.local).
//   3. The dev stage endpoint, so a fresh clone runs with no setup.

declare global {
  interface Window {
    APP_CONFIG?: { wsApiUrl?: string };
  }
}

const DEFAULT_WS_API_URL = 'wss://api.dev.rps.radapplab.com';

export const WS_API_URL: string =
  window.APP_CONFIG?.wsApiUrl || import.meta.env.VITE_WS_API_URL || DEFAULT_WS_API_URL;

/** Seconds of round-result display before the next round's timer starts. */
export const ROUND_RESULT_SECONDS = 3;

/** Fallback round length if a PROMPT ever arrives without `time_limit_seconds`. */
export const DEFAULT_ROUND_SECONDS = 20;
